// src/services/storage.ts
// Local storage wrapper for web

const STORAGE_KEYS = {
  AUTH_TOKEN: 'majengo_auth_token',
  USER: 'majengo_user',
  PROFILE: 'majengo_profile',
  THEME: 'majengo_theme',
};

export const storage = {
  // Get item from localStorage
  getItem: async (key: string): Promise<string | null> => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error('Error getting item from storage:', error);
      return null;
    }
  },

  // Set item in localStorage
  setItem: async (key: string, value: string): Promise<void> => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error('Error setting item in storage:', error);
    }
  },

  // Remove item from localStorage
  removeItem: async (key: string): Promise<void> => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error removing item from storage:', error);
    }
  },

  // Clear all storage
  clear: async (): Promise<void> => {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing storage:', error);
    }
  },

  // Get JSON object
  getJSON: async <T>(key: string): Promise<T | null> => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error('Error getting JSON from storage:', error);
      return null;
    }
  },

  // Set JSON object
  setJSON: async <T>(key: string, value: T): Promise<void> => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error('Error setting JSON in storage:', error);
    }
  },
};

export { STORAGE_KEYS };
